module.exports = {"id":"230286","name":"Michel Cruceiro","rating":"73","photo":"./data/images/photos/0/230286.png","club":{"name":"Atlético Mineiro","logo":"./data/images/clubs/AtleticoMineiro.png"},"positions":["MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichelCruceiro0.json
// module id = 2997
// module chunks = 0